import type { FC, ReactNode } from 'react';

const SectionHeaderCenter: FC<{ children: ReactNode }> = ({ children }) => children;

export default SectionHeaderCenter;